<template v-if="this.user.loggedIn">
  <div id="device-infos">
    <!-- <div id="fixed-table-header" :style="{display: displayStyle}">
      <table class="table">
        <thead>
          <tr>
            <th>CL Art. Nr.</th>
            <th>Apple Art. Nr.</th>
            <th>Bezeichnung</th>
            <th>E-ID</th>
            <th>IMEI</th>
            <th>Seriennummer</th>
            <th>MAC-Adresse</th>
          </tr>
        </thead>
      </table>
    </div> -->
    <div class="m-3">
      <b-card no-body>
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <div class="w-25">
              <b-form-textarea
                v-model="filter"
                placeholder="1 Suchbegriff/Zeile eingeben"
                rows="1"
                debounce="500"></b-form-textarea>
            </div>
            <div class="d-flex justify-content-end" style="gap: 1rem;">
              <b-button @click="selectAllRows">Alle auswählen</b-button>
              <b-button @click="clearSelected">Auswahl aufheben</b-button>
              <b-button @click="exportSelected">Auswahl exportieren</b-button>
            </div>
          </div>
        </template>

        <b-table
          striped
          :items="loadData"
          :fields="fields"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :busy.sync="isBusy"
          selectable
          :select-mode="'multi'"
          @row-selected="onRowSelected"
          ref="selectableTable"
          show-empty>
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #empty>
            Bitte gib einen oder mehrere Suchbegriffe ein.
          </template>
          <template #emptyfiltered>
            Es wurden keine Ergebnisse gefunden.
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {firestore} from "../plugins/firebase";
  import {collection, getDocs, query, where, or} from "firebase/firestore";

  export default {
    name: "DeviceInfos",
    computed: {
      ...mapGetters({
        user: "user",
      }),
    },
    data() {
      return {
        selected: [],
        sortBy: "comlineArtNo",
        sortDesc: true,
        items: [],
        filter: "",
        displayStyle: "none",
        isBusy: false,
        fields: [
          {
            key: "comlineArtNo",
            label: "CL Art. Nr.",
            sortable: true,
          },
          {
            key: "appleArtNo",
            label: "Apple Art. Nr.",
            sortable: true,
          },
          {
            key: "name",
            label: "Bezeichnung",
            sortable: true,
          },
          {
            key: "eid",
            label: "E-ID",
            sortable: true,
          },
          {
            key: "imei",
            label: "IMEI",
            sortable: true,
          },
          {
            key: "serialNumber",
            sortable: true,
          },
          {
            key: "macAddress",
            label: "MAC-Adresse",
            sortable: true,
          },
        ],
      };
    },
  methods: {
      onRowSelected(items) {
        this.selected = items
      },
      exportSelected() {
        if (this.selected.length > 0) {
          const XLSX = require("xlsx");
          const worksheet = XLSX.utils.json_to_sheet(this.selected);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Devices");

          const currentDate = new Date().toISOString().split("T")[0];
          const fileName = `${currentDate}-device-infos.xlsx`;
          XLSX.writeFile(workbook, fileName);
        } else {
          console.warn("No items selected to export.");
        }
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      async loadData(ctx) {
        if (ctx.filter !== "") {
          try {
            const deviceInfosRef = collection(firestore, "device-infos-new");
            const searchValues = ctx.filter.split("\n");
            const filteredSearchValues = searchValues.filter(
              (value) => value.trim() !== ""
            );

            const promises = filteredSearchValues.map((value) => {
              const duplicatedSearchValues = [value, `S${value}`, value.slice(1)];

              console.log("Searching for:", duplicatedSearchValues);

              const q = query(
                deviceInfosRef,
                or(
                  where("comlineArtNo", "in", duplicatedSearchValues),
                  where("appleArtNo", "in", duplicatedSearchValues),
                  where("name", "in", duplicatedSearchValues),
                  where("eid", "in", duplicatedSearchValues),
                  where("imei", "in", duplicatedSearchValues),
                  where("serialNumber", "in", duplicatedSearchValues),
                  where("macAddress", "in", duplicatedSearchValues)
                )
              );

              return getDocs(q);
            });

            const documentSnapshots = await Promise.allSettled(promises);

            const allDocs = documentSnapshots.flatMap((snapshot) => {
              if (snapshot.status === "fulfilled") {
                console.log("Found documents:", snapshot.value.docs);
                return snapshot.value.docs;
              } else {
                console.error("Error fetching documents:", snapshot.reason);
                return [];
              }
            });

            const allData = allDocs.map((doc) => doc.data());

            return allData;
          } catch (err) {
            console.error("Error loading data from Firestore:", err);
            return [];
          }
        } else {
          return [];
        }
      },
      handleScroll() {
        if (window.scrollY > 135) {
          this.displayStyle = "block";
        } else {
          this.displayStyle = "none";
        }
      },
    },
    async mounted() {
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
  };
</script>

<style scoped>
  #fixed-table-header {
    position: fixed;
    z-index: 1;
    top: 60px;
    width: 100%;
    left: 0;
    background-color: #fff;
    box-sizing: border-box;
    padding-left: 17px;
    padding-right: 17px;
    border-bottom: 2px solid #dee2e6;
  }
  #fixed-table-header table {
    width: 100%;
    margin-bottom: 0;
  }
  #fixed-table-header th {
    border-bottom: 0 !important;
  }
</style>

<!-- <style>
  #device-infos .table th:nth-child(1),
  #device-infos .table th:nth-child(2) {
    width: 160px !important;
  }
  #device-infos .table th:nth-child(4),
  #device-infos .table th:nth-child(5),
  #device-infos .table th:nth-child(6),
  #device-infos .table th:nth-child(7),
  #device-infos .table th:nth-child(8) {
    width: 120px !important;
  }
</style> -->
